export default class FormResult {
  status = 0;
  message = '';
  response = null;

  constructor(result, message = '') {
    if (result instanceof Error && result.name === 'ApiError') {
      this.response = result;
      this.status = result.status;
      this.message = (result.response && result.response.error) || result.statusText;
    } else if (result instanceof Error && result.name === 'RequestError') {
      this.response = result;
      this.status = 0;
      this.message = result.message;
    } else if (result instanceof Error) {
      this.response = result;
      this.status = 500;
      this.message = result.message;
    } else {
      this.status = result;
      this.message = message;
    }
  }
}



// WEBPACK FOOTER //
// ./src/FormResult.js